import React, { useEffect, useState } from 'react';
import { T, TraksConsumer } from '../../traks';
import { APIGet, APIPost } from '../../API';
import { RenderIf } from '../../helpers/RenderIf';
import { Input, PhoneInp, TextArea } from '../Input';
import LinkCopy from '../LinkCopy';
import { Loading } from '../Loading';
import { AlertModal } from '../Modals';
import { ConfirmContent } from '../Modals/ConfirmModal';
import Dropdown from '../DropDown';


const SetDuration = ({ shareSettings, setShareSettings, render_static }) => {
    const durationArray = [
        { duration: 3600, text: render_static(<T>1 hour</T>) },
        { duration: 86400, text: render_static(<T>1 day</T>) },
        { duration: 604800, text: render_static(<T>1 week</T>) }
    ]

    const Duration = ({ checked, onChange, text }) => {
        return (
            <div className="d-flex flex-row">
                <input type="radio" className="me-2" onChange={onChange} checked={checked} />
                <span>{text}</span>
            </div>
        )
    }

    return (
        <div className="d-flex flex-column mt-5">
            <T>Set access duration</T>
            {durationArray.map(({ duration, text }, index) =>
                <Duration
                    key={index + "dur"}
                    onChange={() => setShareSettings({ ...shareSettings, duration })}
                    checked={shareSettings.duration === duration}
                    text={text}
                />
            )}
        </div>
    )
}
const LinkHeader = ({ screen_name }) => (
    <div>
        <div>
            <T>Here is the link you can send to </T>{screen_name}
        </div>
    </div>
)

const TwoFactorSettings = ({ shareSettings, setShareSettings }) => {
    const [two_fa, setTwo_fa] = useState(shareSettings.two_fa)

    useEffect(() => {
        setShareSettings({ ...shareSettings, two_fa })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [two_fa])

    const TwoFaType = (two_fa["type"] && two_fa["type"] === "phone")
        ? <T>Phone</T>
        : (two_fa["type"] && two_fa["type"] === "email")
            ? <T>Email</T>
            : <T>Choose</T>

    return (
        <>
            <div className="mt-5">
                <T>Chose the method of two factor verification</T>
            </div>
            <Dropdown toggleText={TwoFaType}>
                <button
                    onClick={() => setTwo_fa({ ...two_fa, type: "phone", email: "" })}
                >
                    <T>Phone</T>
                </button>
                <button
                    onClick={() => setTwo_fa({ ...two_fa, type: "email", phone_number: "" })}
                >
                    <T>Email</T>
                </button>
            </Dropdown>
            <RenderIf condition={two_fa.type === "phone"}>
                <PhoneInp
                    className="mt-4"
                    setPhoneNumber={(phone) => setTwo_fa({ ...two_fa, phone_number: phone })}
                />
            </RenderIf>
            <RenderIf condition={two_fa.type === "email"}>
                <Input
                    dataCy={"email"}
                    type="email"
                    className="mt-3"
                    placeholder={<T>insert email</T>}
                    onChange={(email) => setTwo_fa({ ...two_fa, email })}
                />
            </RenderIf>
        </>
    )
}

const Comment = ({ setShareSettings, shareSettings, ...props }) => <TextArea placeholder={props.render_static(<T>Add a comment</T>)} onChange={(e) => setShareSettings({ ...shareSettings, "comment": e })} />

const ShareWhistle = ({ whistle, ...props }) => {
    const defaultTwoFa = { type: null, email: "", phone_number: "" }
    const [showConfirm, setShowConfirm] = useState(false)
    const [showLoading, setShowLoading] = useState(false)
    const [alertType, setAlertType] = useState({ type: "", text: "" })
    const [showAlert, setShowAlert] = useState(false)
    const whistle_access_id = whistle.whistle_access_id || null
    const whistle_id = whistle.id
    const companyId = whistle["company_id"]
    const [companySettings, setCompanySettings] = useState(undefined);
    const [link, setLink] = useState(undefined)
    const [shareSettings, setShareSettings] = useState({
        action: "share_whistle",
        recipient_id: null,
        screen_name: null,
        type: "link",
        comment: "",
        duration: null,
        two_fa: defaultTwoFa,
        company_id: companyId,
        access_id: whistle_access_id
    })

    const getCompanySettings = () => {
        const resource = `companies/${whistle.company_id}`
        APIGet(resource).then(res => {
            setCompanySettings(res.data)
        }).catch(err => {
            setShowLoading(false)
            setAlertType({ type: "error", text: err.response.data })
            setShowAlert(true)
        })
    }

    const confirmText = {
        header: props.render_static(<T>Share Entry</T>),
        body: props.render_static(<T>Are you sure you want to give access to the entry?</T>)
    }

    const ShareWhistle = () => {
        if (!showConfirm) {
            setShowConfirm(true)
            return
        }
        setShowLoading(true)
        const resource = "whistles/" + whistle_id
        APIPost(resource, shareSettings).then(res => {
            setShowLoading(false)
            setAlertType({ type: "success", text: "Entry successfully shared" })
            setShowAlert(true)
            setShowConfirm(false)
            if (res.data.access_link) {
                setLink(res.data.access_link)
            }
        }).catch(err => {
            setShowLoading(false)
            setAlertType({ type: "error", text: err.response.data })
            setShowAlert(true)
        })
    }

    const isSubmitButtonDisabled = () => {
        const two_fa = shareSettings.two_fa
        if (!shareSettings.screen_name)
            return true

        if (!two_fa.type || (two_fa.email === "" && two_fa.phone_number === ""))
            return true

        return false
    }

    useEffect(() => {
        getCompanySettings()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (companySettings === undefined)
        return (
            <>
                <Loading
                    showLoading={true}
                    inFront
                />
                <AlertModal
                    isShowing={showAlert}
                    setIsShowing={setShowAlert}
                    type={alertType.type}
                    text={alertType.text}
                />
            </>
        )



    return (
        <RenderIf condition={companySettings !== undefined}>
            <RenderIf condition={!showConfirm}>
                {link && (
                    <div className="mb-5">
                        <LinkHeader screen_name={shareSettings.screen_name} />
                        <LinkCopy
                            link={"whistle"}
                            pathId={link}
                        />
                    </div>
                )}
                <Input
                    dataCy="linkAlias"
                    type="text"
                    placeholder={<T>Give your link an alias</T>}
                    onChange={(recipient) => setShareSettings({ ...shareSettings, screen_name: recipient })}
                />
                <div className="col-12">
                    <SetDuration
                        shareSettings={shareSettings}
                        setShareSettings={setShareSettings}
                        render_static={props.render_static}
                    />
                </div>
                <TwoFactorSettings
                    shareSettings={shareSettings}
                    setShareSettings={setShareSettings}
                />
                <div className="mt-5">
                    <TraksConsumer>
                        <Comment setShareSettings={setShareSettings} shareSettings={shareSettings} />
                    </TraksConsumer>
                </div>
                <button
                    className="btn btn_green mt-5 mb-3"
                    disabled={isSubmitButtonDisabled()}
                    onClick={ShareWhistle}
                >
                    <T>SHARE</T>
                </button>
            </RenderIf>
            <Loading
                showLoading={showLoading}
                inFront
            />
            <RenderIf condition={showConfirm}>
                <ConfirmContent
                    header={confirmText.header}
                    body={confirmText.body}
                    onConfirm={ShareWhistle}
                    hide={() => setShowConfirm(false)}
                />
            </RenderIf>
            <AlertModal
                isShowing={showAlert}
                setIsShowing={setShowAlert}
                type={alertType.type}
                text={alertType.text}
            />
        </RenderIf>
    )
};

export default ShareWhistle;
